import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyle = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            textboxStyle: css({
                transform: 'translate3d(0, 0, 0)', // create a stacking context
                '.vn-trailing_button': {
                    position: 'fixed',
                    right: theme.orbitalSeven,
                    zIndex: 1, // this ensures the clear button appears _above_ the input
                },
            }),
        }),
        [theme.orbitalSeven]
    );
};

export default useStyle;
